import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const questions = [{
  id: 1,
  text: '¿Cansado de que no te alcance la plata?',
  image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop'
}, {
  id: 2,
  text: '¿Cansado de trabajar de 9 a 5 por un salario que no te alcanza para nada?',
  image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop'
}, {
  id: 3,
  text: '¿Querés independizarte y no encontrás la manera?',
  image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=600&h=400&fit=crop'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-slate-50" data-id="element-23">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-24">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-blue-100/50 blur-3xl" data-id="element-25" />
        <div className="absolute top-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-emerald-100/40 blur-3xl" data-id="element-26" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" variants={containerVariants} initial="hidden" animate="visible" data-id="element-28">
          {questions.map(q => <motion.div key={q.id} variants={itemVariants} className="bg-white rounded-2xl overflow-hidden shadow-soft border border-slate-100 flex flex-col" data-id="element-29">
              <div className="h-48 overflow-hidden relative" data-id="element-30">
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" data-id="element-31" />
                <img src={q.image} alt="Emprendimiento digital" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-32" />
              </div>
              <div className="p-6 flex-grow flex items-center justify-center text-center bg-white z-20 relative -mt-4 rounded-t-2xl" data-id="element-33">
                <p className="text-lg font-medium text-slate-800 leading-snug" data-id="element-34">
                  {q.text}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div className="text-center max-w-4xl mx-auto mt-12" initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.2
      }} data-id="element-35">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold tracking-tight text-slate-900 mb-6" data-id="element-36">
            <span className="block" data-id="element-37">
              Aprendé a{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-green" data-id="element-38">
                vender por internet
              </span>
            </span>
            <span className="block mt-2" data-id="element-39">
              con herramientas de{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-green" data-id="element-40">
                Inteligencia Artificial
              </span>
            </span>
            <span className="block mt-2" data-id="element-41">
              para transformar tu conocimiento, tu profesión u oficio en un
              negocio online rentable.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-slate-600 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-42">
            Aprendé paso a paso cómo vender por internet y empezar a generar
            ingresos desde tu casa, incluso si hoy empezás desde cero.
          </p>

          <motion.button onClick={scrollToPricing} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white transition-all duration-200 bg-brand-blue border border-transparent rounded-full shadow-lg hover:bg-blue-800 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue" data-id="element-43">
            Quiero Empezar Ahora
            <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-44" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}